const NUMBER_KEYS = new Set(['id', 'total_amount', 'quantity']);
const DATE_KEYS = new Set(['booking_date', 'dispatch_date', 'return_date', 'quotation_date', 'event_date']);

const isEmpty = (value) => value == null || value === '';

export const compareSortValues = (a, b, key) => {
  const aVal = a?.[key];
  const bVal = b?.[key];

  if (NUMBER_KEYS.has(key)) {
    const aNum = Number(aVal);
    const bNum = Number(bVal);
    if (Number.isNaN(aNum) && Number.isNaN(bNum)) return 0;
    if (Number.isNaN(aNum)) return 1;
    if (Number.isNaN(bNum)) return -1;
    return aNum - bNum;
  }

  if (DATE_KEYS.has(key)) {
    const aEmpty = isEmpty(aVal);
    const bEmpty = isEmpty(bVal);
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;
    return new Date(aVal) - new Date(bVal);
  }

  const aEmpty = isEmpty(aVal);
  const bEmpty = isEmpty(bVal);
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' });
};

export const sortItems = (items, sortBy, sortDir) => {
  if (!sortBy) return items;
  const dir = sortDir === 'desc' ? -1 : 1;
  return [...items].sort((a, b) => compareSortValues(a, b, sortBy) * dir);
};

export const toggleSort = (currentColumn, currentDir, nextColumn) => {
  if (currentColumn === nextColumn) {
    return { sortBy: nextColumn, sortDir: currentDir === 'asc' ? 'desc' : 'asc' };
  }
  return { sortBy: nextColumn, sortDir: 'asc' };
};
